module.exports = __webpack_public_path__ + "img/notified.8d1f1279.svg";